import * as actionTypes from "./actionTypes";
import * as types from "./types";
import {GroupState} from "./types";

const initialState: {[id: string]: types.GroupState} = {};

export const GroupsReducer = (state = initialState, action: types.GroupActions) => {
  let newState: { [group: string]: GroupState };
  switch (action.type) {
    case actionTypes.FETCH_GROUP_USERS_REQUEST:
      newState = {...state};
      newState[`${action.group}`] = {
        pending: true,
        users: [],
        error: null,
      }
      return newState;
    case actionTypes.FETCH_GROUP_USERS_SUCCESS:
      newState = {...state};
      newState[`${action.group}`] = {
          pending: false,
          users: action.payload.userName,
          error: null,
      };
      return newState
    case actionTypes.FETCH_GROUP_USERS_FAILURE:
      newState = {...state};
      newState[`${action.group}`] = {
        pending: false,
        users: [],
        error: action.payload.error,
      }
      return newState
    default:
      return {
        ...state,
      };
  }
};

export default GroupsReducer;

